import Game2 from './Game2';
export default Game2;


// WEBPACK FOOTER //
// ./src/containers/Game2/index.js